import React from 'react';
import { connect } from 'react-redux';

import { 
  insertRow,
  removeRow,
  insertPartial
} from '../actions/AppActions';

const ButtonBox = ({ insertRow, removeRow, insertPartial }) => (
    <td className="btn-group">
        <button onClick={e => insertPartial("addPartial")}>Insert Partial</button>
        <button onClick={e => insertRow("addRow")}>+</button>
        <button onClick={e => removeRow("deleteRow")}>-</button>
    </td>
)

const mapStateToProps = state => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({
    insertRow: () => dispatch(insertRow(ownProps.rowIndex, ownProps.billNumber)),
    insertPartial: () => dispatch(insertPartial(ownProps.rowIndex, ownProps.billNumber)),
    removeRow: () => dispatch(removeRow(ownProps.rowIndex, ownProps.billNumber))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ButtonBox);